"use client";

import dynamic from "next/dynamic";
import type { LineupZipControlProps } from "./lineup-zip-control.client";

/**
 * `LineupZipControl`, in a chunk of its own. Its `"use client"` boundary is what splits it: the
 * filler that renders it is reached statically from every v3 page, as with `ZipCodeLazy`.
 */
export const LineupZipControlLazy = dynamic<LineupZipControlProps>(
  () => import("./lineup-zip-control.client").then(m => m.LineupZipControl)
);

export default LineupZipControlLazy;
